import React from "react";
import { Link } from "react-router-dom";
import { FileText, Download, Lock } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";
import { Stagger, itemVariant } from "../components/Reveal";
import { DOWNLOADS } from "../data/content";

export default function Downloads() {
  const { t, lang } = useLang();
  return (
    <>
      <Seo title="Downloads – Datenblätter, SDS & Zertifikate | PlastoNord"
        description="Technische Datenblätter (TDS), Sicherheitsdatenblätter (SDS), Konformitätszertifikate (COA) und Verarbeitungsrichtlinien für TPU und technische Kunststoffe."
        path="/downloads" />
      <PageHero overline={t("nav.downloads")}
        title={lang === "de" ? "Dokumente & technische Unterlagen" : "Documents & technical resources"}
        subtitle={lang === "de" ? "Datenblätter, Sicherheitsdatenblätter und Zertifikate – produktspezifisch auf Anfrage und im Kundenportal." : "Data sheets, safety data sheets and certificates – product-specific on request and in the customer portal."} />
      <section className="py-24">
        <div className="pn-container">
          <Stagger className="grid gap-5 sm:grid-cols-2">
            {DOWNLOADS.map((d) => (
              <motion.div key={d.de} variants={itemVariant} className="pn-card flex items-center justify-between p-6">
                <div className="flex items-center gap-4">
                  <span className="grid h-11 w-11 place-items-center rounded-lg bg-[#FBEADD] text-[#16181D]"><FileText size={19} /></span>
                  <div>
                    <h3 className="font-head text-base font-semibold text-[#16181D]">{lang === "de" ? d.de : d.en}</h3>
                    <p className="text-xs text-[#4a4d52]">{d.type} · {t("common.onRequest")}</p>
                  </div>
                </div>
                <Link to="/kontakt" className="grid h-10 w-10 place-items-center rounded-full border border-[#e4e9f0] text-[#16181D] transition-colors hover:border-[#E2611C] hover:text-[#E2611C]"><Download size={17} /></Link>
              </motion.div>
            ))}
          </Stagger>
          <div className="mt-10 flex items-center gap-3 rounded-xl bg-[#f6f8fb] p-5 text-sm text-[#4a4d52]">
            <Lock size={16} className="text-[#E2611C]" /> {lang === "de" ? "Kundenspezifische Dokumente werden sicher im Kundenportal bereitgestellt." : "Customer-specific documents are provided securely in the customer portal."}
          </div>
        </div>
      </section>
    </>
  );
}
